import { selectProcedureById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"
import { appStore } from "src/store"
import { procedureDetailsViewStaticData } from "src/views/ProcedureDetailsView/constants"
import { ProcedureDetailsView } from "src/views/ProcedureDetailsView/ProcedureDetailsView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedures/$procedureId",
)({
	component: ProcedureDetailsView,
	staticData: procedureDetailsViewStaticData,
	remountDeps: ({ params }) => [params.organizationId, params.projectId, params.procedureId],
	loader: ({ params }) => {
		const procedure = selectProcedureById(params.procedureId)(appStore.getState())
		if (!procedure) throw notFound()
	},
})
